import * as React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import { useNavigate } from "react-router-dom";
import { useGetUserListQuery } from "../../../../api/apiSlice";
import TableOnboard from "./TableOnboard";
//     getModalOpen,  setModalOpen, 
//   } from "./siteSlice";
import Footer from "../../../../Footer/Footer";
export default function LandingOnboardUsers() {
  let navigate = useNavigate();

  const handleGoToClients = (event) => {
    navigate("/clients/");
  };
  const
  {
  data: userData,
  isLoading: userLoading,
  isSuccess: userSuccess,
  isError: userError,
  error: userMessage,
} = useGetUserListQuery();

if (userLoading) {
  return (
      <div className="center-screen">
          {/* <LoadingSpinner /> */}
      </div>
  );
} else if (userError ) {
  return (
      <div className="center-screen">
          {/* <Error500 /> */}
      </div>
  );
} else {

  return (
    <>

   <TableOnboard user_data={userData.data} />
   <Footer/>
    </>
  );
}
}